<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import { REAL_BRL } from '../../../../utils/helpers/money'
  import { VMoney } from 'v-money'
  import service, {getArrematanteGrv} from '../../../../domain/grv/services'
  import retiradaService, {findRetirada} from '../../../../domain/retirada/services'
  import {isArray} from 'lodash'
  import moment from 'moment'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import {Status as RetiradaStatus, ARRAY_STATUS_RETIRADO_POR_LEILAO} from '../../../../domain/grv/helpers/retirada-status'
  import {STATUS_NO_LEILAO, STATUS_RETIRADO_POR_LEILAO} from '../../../../domain/grv/helpers/GrvStatus'
  import {GRV_DETRO, GRV_POLICIA_CIVIL} from '../../../../domain/grv/helpers/tipos-grv'

  const TIPOS_DOCUMENTO = {
    1: 'cpf',
    2: 'cnpj',
    3: 'matricula'
  }

  export default {
    components: {
      VisualizarPendenciasVeiculo: () => import('./VisualizarPendenciasVeiculo'),
      PopupViewer
    },
    nome: 'Retirada',
    directives: {mask, money: VMoney},
    props: {
      grvId: {
        type: Number,
        required: false
      }
    },
    data () {
      return {
        money: REAL_BRL,
        isLoading: false,
        data: null,
        retirada: {
          dataRetirada: null,
          nome: null,
          tipoDocumento: 1,
          numeroDocumento: null,
          numeroRg: null,
          endereco: null,
          observacao: null,
          status: null,
          multaDetroPaga: false,
          autoDeEntrega: null,
          cep: null,
          telefone: null,
          telefone2: null,
          telefone3: null
        },
        extraModel: {
          cpf: null,
          cnpj: null,
          matricula: null
        },
        cadastroError: null,
        showVisualizacaoPendencias: false,
        isPreenchidoAutomaticamente: false,
        origemDadosAutoPreenchimento: 'da pré-retirada realizada para esta GRV'
      }
    },
    computed: {
      statusList () {
        if (this.data.status === STATUS_NO_LEILAO) {
          const statusesRestritosRetiradaPorLeilao = [
            ...ARRAY_STATUS_RETIRADO_POR_LEILAO
          ]
          const statuses = JSON.parse(JSON.stringify(RetiradaStatus))

          for (let key in statuses) {
            if (!statuses.hasOwnProperty(key)) continue
            statuses[key].disabled = !statusesRestritosRetiradaPorLeilao.includes(+key)
          }
          return statuses
        }
        return RetiradaStatus
      },
      isMultaDetroPaga () {
        return this.retirada.multaDetroPaga
      },
      numeroDocumento () {
        const {cpf, cnpj, matricula} = this.extraModel
        return (cpf || cnpj || matricula || '').replace(/\D/, '')
      },
      today () {
        const date = new Date()
        const day = date.getUTCDate().toString().padStart(2, '0')
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
        const year = date.getUTCFullYear()

        return `${day}/${month}/${year}`
      },
      isDataRetiradaMaiorQueHoje () {
        const today = this.today.split('/').reverse().join('-')
        const date = this.retirada.dataRetirada.split('/').reverse().join('-')

        return new Date(today) < new Date(date)
      },
      isDesabilitarCampos () {
        const {multaDetroPaga, status} = this.retirada
        const {tipoProcesso} = this.data
        const array = [
          ...ARRAY_STATUS_RETIRADO_POR_LEILAO
        ]
        return !multaDetroPaga && !array.includes(+status) && (tipoProcesso === GRV_DETRO)
      },
      isGrvPoliciaCivil () {
        return this.data.tipoProcesso === GRV_POLICIA_CIVIL
      }
    },
    beforeMount () {
      this.retirada.dataRetirada = this.today
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      start () {
        this.$loaderOverlay.open().message('Definindo parâmetros da retirada')
        service.find((this.grvId || this.$route.params.id), this.isGgv)
          .then((response) => {
            this.data = response.data
            if (response.data.retirada) {
              this.carregarRetirada(response.data.retirada.id)
            } else {
              if (this.data.status === STATUS_NO_LEILAO || this.data.status === STATUS_RETIRADO_POR_LEILAO) {
                this.preecheComDadosDoArrematante()
              } else {
                this.preecheComDadosPreRetirada()
              }

              const {atendimentos} = this.data
              if (atendimentos.length) {
                const atendimento = atendimentos[atendimentos.length - 1]
                if (!this.retirada.cep) {
                  this.retirada.cep = atendimento.cep
                }
                this.retirada.telefone = atendimento.telefone1
                this.retirada.telefone2 = atendimento.telefone2
                this.retirada.telefone3 = atendimento.telefone3
                this.retirada.numeroRg = atendimento.rg
              }

              this.$loaderOverlay.hide()
            }
          })
          .catch((response) => {
            this.$loaderOverlay.hide()
            console.log(response)
          })
      },
      carregarRetirada (id) {
        if (!id) return
        this.$loaderOverlay.message('Carregando dados de retirada...')
        findRetirada(id)
          .then(response => {
            this.retirada = response.data
            this.retirada.dataRetirada = this.retirada.dataRetirada.date.split(' ')[0].split('-').reverse().join('/')
            const tipoDocumento = TIPOS_DOCUMENTO[this.retirada.tipoDocumento]
            this.extraModel[tipoDocumento] = this.retirada.numeroDocumento
            this.$loaderOverlay.hide()
          })
          .catch(error => {
            alert('Ocorreu um erro ao carregar os dados da retirada. Contate o suporte.')
            this.$loaderOverlay.hide()
            console.log(error)
          })
      },
      preecheComDadosPreRetirada () {
        if (!(this.data.preretiradas || []).length) return
        const preretirada = this.data.preretiradas[this.data.preretiradas.length - 1]
        this.retirada.nome = preretirada.nomePagador
        this.retirada.tipoDocumento = preretirada.tipoDocumento
        const {tipoDocumento, documentoPagador} = preretirada
        this.extraModel[TIPOS_DOCUMENTO[tipoDocumento]] = documentoPagador
        const {enderecoPagador, bairroPagador, numeroPagador, complementoPagador, cidadePagador, estadoPagador, cepPagador} = preretirada
        this.retirada.cep = cepPagador
        this.retirada.endereco = `${enderecoPagador}, ${numeroPagador}, ${complementoPagador}, ${bairroPagador} - ${cidadePagador} - ${estadoPagador}`
        this.isPreenchidoAutomaticamente = true
      },
      preecheComDadosDoArrematante () {
        getArrematanteGrv((this.grvId || this.$route.params.id))
        .then(response => {
          const {tipo: tipoDocumento, nome, documento, pfRg, enderecos} = response.data.pessoa
          this.retirada.nome = nome
          this.retirada.tipoDocumento = tipoDocumento
          this.extraModel[TIPOS_DOCUMENTO[tipoDocumento]] = documento
          this.retirada.numeroRg = pfRg
          const {logradouro, bairro, numero, complemento, cidadeOutros, ufOutros, cep} = enderecos[0]
          this.retirada.cep = cep
          this.retirada.endereco = `${logradouro}, ${numero}, ${complemento}, ${bairro} - ${cidadeOutros} - ${ufOutros}`
          this.origemDadosAutoPreenchimento = 'do arrematante do lote relacionado a esta GRV'
          this.isPreenchidoAutomaticamente = true
        })
        .catch(error => {
          console.log(error)
        })
      },
      submit (evt, force = false) {
        const getOnlyNumbers = string => (String(string) || '').replace(/\D/g, '')

        if (this.isDataRetiradaMaiorQueHoje) {
          alert('Data de retirada não pode ser maior que a data atual')
          this.$refs.dataRetirada.focus()
          return
        }
        const {autoDeEntrega = ''} = this.retirada
        let autoDeEntregaFormatado = null
        if (this.isGrvPoliciaCivil) {
          autoDeEntregaFormatado = getOnlyNumbers(autoDeEntrega)
          if (autoDeEntregaFormatado.length !== 12) {
            alert('Auto de Entrega inválido.')
            this.$refs.autoDeEntrega.focus()
            return
          }
        }

        let confirm = window.confirm('Tem certeza que deseja registrar a retirada?')
        if (!confirm) return
        this.cadastroError = null
        this.$loaderOverlay.open().message('Processando')
        this.$bar.start()
        window.setTimeout(() => {
          this.$loaderOverlay.message('Aguarde, registrando retirada...')
        }, 1000)
        let data = JSON.parse(JSON.stringify(this.retirada))
        data.grv = this.data.id
        if (this.isGrvPoliciaCivil) {
          data.autoDeEntrega = autoDeEntregaFormatado
        }

        if (data.tipoDocumento === 1) {
          data.numeroDocumento = getOnlyNumbers(this.extraModel.cpf)
        } else if (data.tipoDocumento === 2) {
          data.numeroDocumento = getOnlyNumbers(this.extraModel.cnpj)
        } else {
          data.numeroDocumento = getOnlyNumbers(this.extraModel.matricula)
        }

        data.cep = getOnlyNumbers(data.cep)
        data.telefone = getOnlyNumbers(data.telefone)
        data.telefone2 = getOnlyNumbers(data.telefone2)
        data.telefone3 = getOnlyNumbers(data.telefone3)

        data.dataRetirada = `${data.dataRetirada} ${moment().format('HH:mm:ss')}`
        retiradaService.cadastro(data, force).then((response) => {
          let callbackEnd = () => {
            this.$bar.finish()
            this.$loaderOverlay.hide()
            if (this.grvId) {
              this.$emit('finishSubmit', data.status)
            } else {
              const nameRoute = this.isGrvPoliciaCivil ? 'roubo-furto.visualizar.patio' : 'grv.visualizar.patio'
              this.$router.push({name: nameRoute, params: {id: this.data.id}})
            }
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      },
      openVisualizacaoPendencias () {
        this.showVisualizacaoPendencias = true
      },
      closeVisualizacaoPendencias () {
        this.showVisualizacaoPendencias = false
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition" v-if="data">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-warning lter b-b wrapper-md" v-if="isPreenchidoAutomaticamente">
              <div class="row">
                <div class="col-xs-12">
                  <h1 class="font-thin h4 text-black">
                    <i class="fa fa-exclamation-circle"></i> <strong>Atenção</strong><br>
                    Os campos foram preenchidos automaticamente com base nos dados <strong>{{origemDadosAutoPreenchimento}}</strong>.
                    <br>
                    É recomendado conferir os dados antes de confirmar.
                  </h1>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="clearfix">
                <div>
                  <form v-on:submit.prevent="submit" class="bs-example form-horizontal form-grv">
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Retirada
                          </h1>
                        </div>
                        <div class="col-sm-12 m-t-md">
                          <div tabindex="-1" v-if="data.codigoInfracao === '4.32'" class="alert alert-danger">
                            <div class="font-bold">Este veículo possui multa DETRO, favor consultar antes de realizar a liberação</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">

                        <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
                          <div class="m-b-sm font-bold">Erro ao registrar a retirada, corrija e tente novamente
                          </div>
                          <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
                          <div>
                            <button class="btn btn-danger btn-md m-t" type="button" @click="openVisualizacaoPendencias">Ver pendências do veículo com a DETRO</button>
                            <button class="btn btn-danger btn-md m-t" type="button" @click="submit(null, true)">Cadastrar retirada mesmo assim</button>
                          </div>
                        </div>

                        <div class="form-group lbl-form">
                          <label class="col-sm-2">GRV</label>
                          <div class="col-sm-10 font-bold">
                            {{data.numero}} - {{isGrvPoliciaCivil ? data.placaOriginal : data.placa}}
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="status" class="col-sm-2 control-label">Status</label>
                          <div class="col-sm-10">
                            <select id="status" required v-model="retirada.status" class="form-control">
                              <option :value="null">Selecione</option>
                              <option :value="index" v-for="(status, index) in statusList"
                                      :key="index" :disabled="status.disabled">{{status.titulo}}
                              </option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="dataPrevista" class="col-sm-2 control-label">Data da retirada</label>
                          <div class="col-sm-10">
                            <input required id="dataPrevista" ref="dataRetirada" type="text" placeholder="dd/mm/yyyy"
                                   v-model="retirada.dataRetirada"
                                   v-mask="'##/##/####'" class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="col-sm-2"></div>
                          <div class="col-sm-10">
                            <label class="i-checks">
                              <input type="checkbox"
                                     v-model="retirada.multaDetroPaga"
                                     tabindex="0" aria-checked="false"
                                     aria-invalid="false">
                              <i></i> Multa DETRO foi paga
                            </label>
                          </div>
                        </div>

                      </div>
                    </div>

                    <!---->
                    <div class="bg-light lter b-b wrapper-md">
                      <div class="row">
                        <div class="col-sm-6 col-xs-12">
                          <h1 class="font-thin h3">
                            Dados de quem está retirando o veículo
                          </h1>
                        </div>
                      </div>
                    </div>

                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="form-group">
                          <label for="nome" class="col-sm-2 control-label">Nome</label>
                          <div class="col-sm-10">
                            <input autocomplete="off" required id="nome" type="text"
                                   v-model="retirada.nome"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-sm-2 control-label">Tipo documento</label>
                          <div class="col-sm-10">
                            <select required v-model="retirada.tipoDocumento" class="form-control" :disabled="isDesabilitarCampos">
                              <option :value="1">CPF</option>
                              <option :value="2">CNPJ</option>
                              <option :value="3">Matrícula</option>
                            </select>
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="numeroDocumento" class="col-sm-2 control-label">Número documento</label>
                          <div class="col-sm-10" v-if="retirada.tipoDocumento === 1">
                            <!-- TODO: Refatorar -->
                            <input autocomplete="off" required id="numeroDocumento" type="text"
                                   v-model="extraModel.cpf"
                                   v-mask="'###.###.###-##'"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                          <div class="col-sm-10" v-if="retirada.tipoDocumento === 2">
                            <input autocomplete="off" required id="numeroDocumento" type="text"
                                   v-model="extraModel.cnpj"
                                   v-mask="'##.###.###/####-##'"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                          <div class="col-sm-10" v-if="retirada.tipoDocumento === 3">
                            <input autocomplete="off" required id="numeroDocumento" type="text"
                                   v-model="extraModel.matricula"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="numeroRg" class="col-sm-2 control-label">Número do RG</label>
                          <div class="col-sm-10">
                            <input id="numeroRg" type="text" v-model="retirada.numeroRg"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="telefone" class="col-sm-2 control-label">Telefone</label>
                          <div class="col-sm-10">
                            <input id="telefone" type="text" class="form-control" v-model="retirada.telefone"
                                   v-mask="'(##) #####-####'"
                                   placeholder="(00) 00000-0000"
                                   :disabled="isDesabilitarCampos"
                            />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="telefone2" class="col-sm-2 control-label">Telefone 2</label>
                          <div class="col-sm-10">
                            <input id="telefone2" type="text" class="form-control" v-model="retirada.telefone2"
                                   v-mask="'(##) #####-####'"
                                   placeholder="(00) 00000-0000"
                                   :disabled="isDesabilitarCampos"
                            />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="telefone3" class="col-sm-2 control-label">Telefone 3</label>
                          <div class="col-sm-10">
                            <input id="telefone3" type="text" class="form-control" v-model="retirada.telefone3"
                                   v-mask="'(##) #####-####'"
                                   placeholder="(00) 00000-0000"
                                   :disabled="isDesabilitarCampos"
                            />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="cep" class="col-sm-2 control-label">CEP</label>
                          <div class="col-sm-10">
                            <input id="cep" type="text" class="form-control" v-model="retirada.cep"
                                   v-mask="'##.###-###'"
                                   :disabled="isDesabilitarCampos"
                                   placeholder="00.000-000"
                            />
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="endereco" class="col-sm-2 control-label">Endereço</label>
                          <div class="col-sm-10">
                            <input required id="endereco" type="text" v-model="retirada.endereco"
                                   :disabled="isDesabilitarCampos"
                                   class="form-control">
                          </div>
                        </div>

                        <div class="form-group" v-if="isGrvPoliciaCivil">
                          <label for="autoDeEntrega" class="col-sm-2 control-label">Auto de Entrega</label>
                          <div class="col-sm-10">
                            <input required id="autoDeEntrega"
                                   type="text"
                                   v-model="retirada.autoDeEntrega"
                                   :disabled="isDesabilitarCampos"
                                   v-mask="'###-#####/####'"
                                   class="form-control"
                                   ref="autoDeEntrega"
                            >
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="observacao" class="col-sm-2 control-label">Observações</label>
                          <div class="col-sm-10">
                            <textarea id="observacao" rows="8" v-model="retirada.observacao"
                                      :disabled="isDesabilitarCampos"
                                      class="form-control">
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!---->

                    <div class="wrapper">
                      <div class="panel-body">
                        <div class="row">
                          <button class="btn btn-success btn-md m-l-xs" :disabled="isDesabilitarCampos">Registrar Retirada</button>
                        </div>
                      </div>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeVisualizacaoPendencias" v-if="showVisualizacaoPendencias" title="Pendências do Veículo">
        <VisualizarPendenciasVeiculo :tipoDocumentoLiberacao="retirada.tipoDocumento" :documentoLiberacao="numeroDocumento" :grv="$route.params.id"></VisualizarPendenciasVeiculo>
      </popup-viewer>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// addRetirada.vue?56ac27a4